<template>
  <v-card class="overflow-hidden bg-gray-d br-0" style="height: 100%">
    <header>
      <slot name="header">
        <top-bar :title="title" v-on:openDrawer="onOpenDrawer"></top-bar>
      </slot>
    </header>

    <nav>
      <slot name="nav">
        <nav-drawer :open="drawer" v-on:closeDrawer="onCloseDrawer"></nav-drawer>
      </slot>
    </nav>

    <main>
      <slot name="main">
        <div class="withdrawal-header">
          <div class="body-wrapper bg-black header-bg-img p-lr-20 p-b-15">
            <h1 class="desktop-view m-t-140 m-b-10">Withdrawal</h1>
            <div class="mobile-view dashboard-header-wrapper input-header-wrapper transaction-filter-date m-b-20">
              <span class="font-sm gray-text">Withdrawable Balance</span>
              <h1 class="font-xxl white-text m-t-3"><sup><i class="fas fa-euro-sign font-xs m-r-5"></i></sup>{{ member.available_balance }}</h1>
              <v-btn rounded class="header-btn gradient-yellow m-t-10" :to="{ name: 'transaction-history' }"><span class="m-r-5 font-xxs bold">Transaction History</span><i class="fas fa-chevron-right"></i></v-btn>
            </div>
          </div>
        </div>
        <v-container class="br-wrapper bg-gray-l">
          <div class="body-wrapper p-b-70">
            <div v-if="isVerified" class="withdrawal-body-wrapper">
              <div class="withdrawal-gateway">
                <v-expansion-panels v-for="cpo in customerPaymentOptions" :key="cpo.code">
                  <v-expansion-panel v-if="cpo.code === 'NETELLER' || cpo.code === 'SKRILL'" class="customize-panel-wrapper">
                    <default-withdrawal-form :customerPaymentOption="cpo" :paymentOption="cpo.code"></default-withdrawal-form>
                  </v-expansion-panel>
                  <v-expansion-panel v-if="cpo.code === 'BITCOIN'" class="customize-panel-wrapper">
                    <btc-withdrawal-form :customerPaymentOption="cpo" :paymentOption="cpo.code"></btc-withdrawal-form>
                  </v-expansion-panel>
                </v-expansion-panels>
              </div>
              <div class="desktop-view withdrawal-balance-desktop">
                <div class="w-100 custom-card-shadow p-20 wb-container white-text">
                  <span class="font-nm">Withdrawable Balance</span>
                  <h1 class="font-xxl m-t-10 m-b-20">{{ member.available_balance }} EUR</h1>
                 
                  <v-btn rounded class="header-btn th-btn m-t-20" :to="{ name: 'transaction-history' }"><span class="m-r-5 font-xs bold">Transaction History</span><i class="fas fa-chevron-right"></i></v-btn>
                </div>
              </div>

              <withdrawal-reminder-dialog
                ref="childReminder"
                title="Reminder:"
                message="Your withdrawal request will be processed within 12-24 hours upon receiving approval from our game provider."
              ></withdrawal-reminder-dialog>
            </div>

            <!-- Unable to withdraw screen -->
            <div v-if="!isVerified" class="screen-container text-center">
              <div class="screen-img-container">
                  <img src="../assets/unable-to-withdraw.svg">
              </div>
              <h1  class="mt-4 black-text">Unable to withdraw</h1>
              <p class="pending-subtext">You need to complete your verification in order to withdraw from your account.</p>

              <!-- kyc button -->
              <div class="text-center mt-5">
                <v-btn class="text-center m-auto kyc-btn" :to="{ name: 'kyc' }">Go to KYC Page</v-btn>
              </div>
              <!-- kyc button end -->
            </div>
            <!-- Unable to withdraw screen end -->
          </div>
        </v-container>
      </slot>
    </main>
    
    <footer>
      <slot name="footer">
        <v-snackbar v-model="snackbar" :multi-line="multiLine" class="font-sm">
          Transaction 20190712-010132-997983-1 Withdrawal has been Acknowledged
          <span class="gray-d-text font-sm underline" @click="snackbar = false" >Dismiss</span>
        </v-snackbar>
      </slot>
    </footer>

  </v-card>
</template>

<script>
import DefaultWithdrawalForm from '@/components/forms/DefaultWithdrawalForm'
import NavDrawer from '@/components/shared/NavDrawer';
import BtcWithdrawalForm from '@/components/forms/BtcWithdrawalForm';
import TopBar from '../components/shared/TopBar';
import storage from '../utility/storage';
import { mapActions, mapGetters } from 'vuex';
import WithdrawalReminderDialog from '../components/elements/dialog/WithdrawalReminderDialog.vue';

export default {
  name: 'Withdrawal',
  components: {
    TopBar,
		DefaultWithdrawalForm,
    BtcWithdrawalForm,
    NavDrawer,
    WithdrawalReminderDialog
  },
  mounted () {
    this.fetchPaymentOptions()
    this.showReminderModal()
  },
  data () {
    return {
      title: 'Withdrawal',
      member: storage.getObject('member'),
      message: null,
      drawer: false,
      dialog: false,
      successDialog: false,
      errorDialog: false,
      withdrawalReminderDialog: false,
      multiLine: true,
      snackbar: false,
      sheet: false,
      isVerified: storage.getObject('member').verified_at !== null,
      date: new Date().toISOString().substr(0, 10),
    }
  },
  methods: {
    logout () {
      this.$store.dispatch('auth/logout').then(() => {
        this.$router.push({ name: 'auth-login' })
      })
    },
    onOpenDrawer(value) {
      this.drawer = value
    },
    onCloseDrawer(value) {
      this.drawer = value
    },
    showReminderModal() {
      this.withdrawalReminderDialog = true
      this.$refs.childReminder.setOpen(true)
    },
    ...mapActions('withdrawal', [
        'fetchPaymentOptions'
    ])
  },
  computed: {
    theme(){
      return (this.$vuetify.theme.dark) ? 'dark' : 'light'
    },
    ...mapGetters('withdrawal', [ 'customerPaymentOptions']),
  },
}
</script>

<style scoped>
  .theme--light.v-sheet {
    background-color: #EFEFF4;
  }
  .v-select__selection--comma {
    font-size: 14px;
  }
  .v-list-item__title {
    font-size: 14px;  
  }
  .v-data-table td {
    font-size: 12px;
  }
  .th-btn {
    background: #fff !important;
    color: #647079 !important;
  }
  .withdrawal-balance-desktop {
    display: none;
  }

  /* unable to withdraw css */
  .screen-img-container{
  display: flex;
  justify-content: center;
  margin-top: 70px;
  }

  .screen-img-container img{
  width: 500px;
  }

  .pending-subtext, .black-text{
  color: #20303C;
  }

  .black-text{
  font-size: 20px;
  }

  /* kyc button css */
  .theme--light.v-btn:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined){
  padding: 0 40px;
  background-color: #FBCB36;
  border-radius: 10px;
  color: white;
  }

  .kyc-btn{
  font-weight: bold!important;
  } 
  /* kyc button css end */
  /* unable to withdraw css end */

  @media screen and (min-width: 600px) {
    .pending-subtext{
    font-size: 13px;
    }
  }

  @media only screen and (min-width: 768px) {
    .withdrawal-header {
      position: relative;
    }
    .withdrawal-header .bg-black {
      background: #EFEFF4 !important;
    }

    .kyc-btn{
      font-weight: bold;
      font-size: 15px;
    }
  }
  @media only screen and (min-width: 1024px) {
    .withdrawal-body-wrapper {
      display: flex;
    }
    .withdrawal-gateway {
      width: 65%;
      margin-right: 20px;
    }
    .withdrawal-balance-desktop {
      display: block;
      width: 35%;
      height: fit-content;
    }
  }
  @media only screen and (min-width: 1030px) {
    .withdrawal-gateway {
      width: 75%;
    }
    .withdrawal-balance-desktop {
      width: 25%;
    }
  }
</style>
